import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SettingsService } from '../services/settings.service';


@Injectable()
export class AuthGuard  {
  constructor(private router: Router, private settings: SettingsService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.tryRoute(route.routeConfig!.data)) return true;

    // Access denies. Try to redirect
    try {
      for (var i = 0; i < route.parent.routeConfig.children.length; i++) {
        if (!route.parent.routeConfig.children[i].redirectTo && this.tryRoute(route.parent.routeConfig.children[i].data, false)) {
          var path = route.parent.routeConfig.children[i].path;

          var p = route.parent;
          while (p.routeConfig != null) {
            path = p.routeConfig.path + "/" + path;
            p = p.parent;
          }

          this.router.navigate([path]);
          return false;
        }
      }
    } catch (ex) { }


      return false;
  }

  private tryRoute(data: any, allowHidden:boolean = true): boolean {
    if (!data) return true;
    if (!allowHidden && data.hidden === true) return false;

    //Require OneWay?
    if ((!data.requireOneWay || this.settings.clientSettings.IsOneWay) || (!data.requireCampaignEnabled || (this.settings.isInAny(['BusinessManager']) && !this.settings.isInAny(['Admin', 'GroupManager', 'LocationManager']) && this.settings.clientSettings.PartnerCampaignEnabled) || (this.settings.isInAny(['Admin', 'GroupManager', 'LocationManager'])))) {
      // Check rights
      if (data.rights != null)
        if (this.settings.may(data.rights)) return true;

      //Check roles and brands if available.
      if (data.roles != null) {
        var brands = data.brands != null && data.brands.length > 0 ? data.brands : null;
        var skipbrands = data.skipbrands != null && data.skipbrands.length > 0 ? data.skipbrands : null;
        if (this.settings.isInAny(data.roles, false, brands, skipbrands)) return true;
      }
    }

    return false;
  }
}
